const BLOCK_TTL_MS = 5 * 60 * 1000;

const blockedPaths = new Map<string, number>();

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

function normalizePath(url: string): string {
  return url.split('?')[0].replaceAll(UUID_RE, ':id');
}

export function isPlanError(status: number, data: any): boolean {
  if (status !== 403 || typeof data?.message !== 'string') return false;
  const msg: string = data.message;
  return (
    msg.includes('not available on your current plan') ||
    (msg.includes('requires the') && msg.includes('plan'))
  );
}

export function blockPath(url: string): void {
  blockedPaths.set(normalizePath(url), Date.now());
}

export function isBlocked(url: string): boolean {
  const blockedAt = blockedPaths.get(normalizePath(url));
  if (blockedAt === undefined) return false;
  if (Date.now() - blockedAt > BLOCK_TTL_MS) {
    blockedPaths.delete(normalizePath(url));
    return false;
  }
  return true;
}

export function clearPlanGates(): void {
  blockedPaths.clear();
}
